module.exports = __webpack_public_path__ + "img/41-s.421c13f1.png";